import { analyticsEvents, } from "./events.js";
// Neither wizard asks for a lens any more; the event schema still carries the slot.
const NO_LENS = "unknown";
export function createOnboardingFunnelTracker(track, now = Date.now) {
    let current = null;
    let startedAt = null;
    let stepEnteredAt = null;
    let skipped = 0;
    // Effects run more than once under StrictMode, and a duplicated start would
    // inflate the top of the funnel in every dev session.
    let started = false;
    // A member can walk away and come back several times. The first time is the
    // useful signal, and finishing is not walking away at all.
    let abandoned = false;
    return {
        observe(step, isResume) {
            if (!started) {
                started = true;
                startedAt = now();
                track(analyticsEvents.onboardingStarted, {
                    is_resume: isResume,
                    entry_step: step.step_name,
                });
                if (isResume)
                    track(analyticsEvents.onboardingResumed, step);
            }
            if (current?.step_name === step.step_name) {
                current = step;
                return false;
            }
            const at = now();
            const previousEnteredAt = stepEnteredAt;
            current = step;
            stepEnteredAt = at;
            // A member can land mid-wizard on a resume, so the start clock may not be
            // set yet when the first step is reported.
            startedAt ??= at;
            track(analyticsEvents.onboardingStepViewed, {
                ...step,
                lens: NO_LENS,
                elapsed_ms: at - startedAt,
                ...(previousEnteredAt === null ? {} : { time_on_previous_step_ms: at - previousEnteredAt }),
            });
            return true;
        },
        exit(exit) {
            if (!current)
                return;
            const properties = {
                ...current,
                lens: NO_LENS,
                time_on_step_ms: stepEnteredAt === null ? 0 : now() - stepEnteredAt,
            };
            if (exit === "skipped") {
                skipped += 1;
                track(analyticsEvents.onboardingStepSkipped, properties);
            }
            // A skipped step is still a step the member got past, so it counts towards
            // the next step's denominator. Reporting only the skip would make every
            // optional step look like a wall.
            track(analyticsEvents.onboardingStepCompleted, properties);
        },
        back() {
            if (!current)
                return;
            track(analyticsEvents.onboardingStepBacked, { ...current, lens: NO_LENS });
        },
        abandon(reason) {
            if (abandoned || !current)
                return;
            abandoned = true;
            track(analyticsEvents.onboardingAbandoned, {
                ...current,
                lens: NO_LENS,
                reason,
                elapsed_ms: now() - (startedAt ?? now()),
            });
        },
        submitFailed(stage) {
            track(analyticsEvents.onboardingSubmitFailed, { stage });
        },
        completed(summary) {
            // The bottom of the funnel has already left the wizard, so a later page
            // hide is a normal exit rather than an abandon.
            abandoned = true;
            track(analyticsEvents.onboardingCompleted, {
                lens: NO_LENS,
                lens_selection_type: "preset",
                duration_ms: now() - (startedAt ?? now()),
                explainer_skipped: false,
                steps_skipped_count: skipped,
                connected_signal_source: summary.connectedSignalSource,
                pulse_answered_count: 0,
            });
        },
        skippedCount: () => skipped,
    };
}
//# sourceMappingURL=onboarding-funnel.js.map